import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Sparkles, RefreshCw, Loader2 } from 'lucide-react';
import { API } from '../lib/api';
import { toast } from 'sonner';

export default function AdminSummaryCard({ caseId, initial, onUpdate, testid = 'admin-summary-card' }) {
  const [summary, setSummary] = useState(initial || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => { setSummary(initial || ''); }, [initial]);

  const regenerate = async () => {
    setLoading(true);
    try {
      const { data } = await API.post(`/ai/admin-summary/${caseId}`);
      setSummary(data.summary || '');
      onUpdate?.(data);
      toast.success('KI-Zusammenfassung aktualisiert');
    } catch (e) {
      toast.error('Fehler bei Zusammenfassung');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="rounded-2xl border-[hsl(var(--accent))]/30 bg-gradient-to-br from-blue-50/70 to-white" data-testid={testid}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-2 mb-2">
          <div className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-[hsl(var(--accent))]" />
            <div className="font-heading font-semibold text-slate-900">10-Sekunden-Briefing</div>
          </div>
          <Button size="sm" variant="outline" onClick={regenerate} disabled={loading} data-testid="admin-summary-regen">
            {loading ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5 mr-1.5" />}
            {loading ? 'KI denkt...' : (summary ? 'Aktualisieren' : 'Generieren')}
          </Button>
        </div>
        {summary ? (
          <pre className="whitespace-pre-wrap text-sm text-slate-800 font-sans leading-relaxed" data-testid="admin-summary-text">{summary}</pre>
        ) : (
          <div className="text-sm text-slate-600">Noch keine Zusammenfassung. Klicken Sie auf „Generieren“ für ein KI-Briefing.</div>
        )}
      </CardContent>
    </Card>
  );
}
